import styled from 'styled-components'

export const StyledButton = styled.button`
  width: ${props => props.width || '400px'};
  display: block;
  float: left;
  border: none;
  border-radius: 3px;
  padding: 10px 0px;
  text-align: center;
  text-decoration: none;
  font: ${props => props.fontSize || '24px'} 'Anton', sans-serif;
  color: #ecf0f1;
  box-shadow: 0px 6px ${({ color }) => getColor(color).dark};
  background: ${({ color }) => getColor(color).light};

  &:active {
    position: relative;
    top: 6px;
    box-shadow: 0px 0px ${({ color }) => getColor(color).dark};
    background: ${({ color }) => getColor(color).dark};
  }

  @media (max-width: 600px) {
    width: ${props => props.mobileWidth || '90%'};
  }
`

const getColor = c => {
  switch (c) {
    case 'red':
      return {
        light: '#e74c3c',
        dark: '#c0392b'
      }
    case 'grey':
      return {
        light: '#34495e',
        dark: '#2c3e50'
      }
    case 'green':
      return {
        light: '#2ecc71',
        dark: '#27ae60'
      }
    default:
      return {
        light: '#9b59b6',
        dark: '#8e44ad'
      }
  }
}

export const StyledSkipButton = styled(StyledButton)`
  box-shadow: 0px 6px #7f8c8d;
  background: #95a5a6;

  &:active {
    box-shadow: 0px 0px #7f8c8d;
    background: #7f8c8d;
  }
`

export const StyledHeader = styled.h1`
  margin: 0;
  font-size: 62px;
  font-family: 'Anton', sans-serif;
  text-shadow: 0 1px 0 #aaa, 0 2px 0 #a9a9a9, 0 3px 0 #999, 0 4px 0 #898989,
    0 5px 0 #888, 0 6px 1px rgba(0, 0, 0, 0.1), 0 0 5px rgba(0, 0, 0, 0.1),
    0 1px 3px rgba(0, 0, 0, 0.3), 0 3px 5px rgba(0, 0, 0, 0.2),
    0 5px 10px rgba(0, 0, 0, 0.25), 0 5px 5px rgba(0, 0, 0, 0.2),
    0 10px 10px rgba(0, 0, 0, 0.15);

  @media (max-width: 600px) {
    font-size: 40px;
  }
`
